
export default function Rtc() {
    return {
        read(address) {
            const cur = new Date();
            switch (address) {
                case 0: return ((cur.getFullYear() & 0xff) >>> 0); 
                case 1: return ((cur.getFullYear() & 0xff00) >>> 8);
                case 2: return cur.getUTCMonth() + 1;
                case 3: return cur.getUTCDate();
                case 4: return cur.getUTCHours();
                case 5: return cur.getUTCMinutes();
                case 6: return cur.getUTCSeconds();
                case 7: return ((cur.getMilliseconds() & 0xff) >>> 0);
                case 8: return ((cur.getMilliseconds() & 0xff00) >>> 8);
                default:
                        return 0;
            }
        },

        write(address) {

        }
    }
}


// WEBPACK FOOTER //
// ./src/emu/rtc.js